import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { AccountSettingsComponent } from './account-settings/account-settings.component';

@NgModule({})
export class AccountSettingsRoutingModule { }
